'use client'

export default function SubHeader({ vendor }: { vendor?: any }) {
  const text = vendor?.headBanner
  if (!text) return null

  const items = Array.from({ length: 8 }, () => text)

  return (
    <section aria-label="Мэдэгдэл" className="w-full overflow-hidden bg-muted text-foreground">
      <p className="sr-only">{text}</p>
      <div aria-hidden className="flex w-max py-5 pill-marquee motion-reduce:animate-none">
        {[...items, ...items].map((item, index) => (
          <span key={index} className="px-8 lg:px-10 text-sm whitespace-nowrap">{item}</span>
        ))}
      </div>
    </section>
  )
}
